package org.solyton.solawi.bid.application.routing

import androidx.compose.runtime.Composable
import org.evoleq.compose.routing.*
import org.evoleq.device.data.mediaType
import org.evoleq.optics.storage.Storage
import org.evoleq.optics.transform.times
import org.jetbrains.compose.web.dom.Text
import org.solyton.solawi.bid.application.data.*
import org.solyton.solawi.bid.application.data.env.type
import org.solyton.solawi.bid.application.data.transform.navbar.navBarIso
import org.solyton.solawi.bid.application.data.transform.user.userIso
import org.solyton.solawi.bid.application.service.seemsToBeLoggerIn
import org.solyton.solawi.bid.application.ui.component.VersionInfo
import org.solyton.solawi.bid.application.ui.page.application.management.ApplicationManagementPage
import org.solyton.solawi.bid.application.ui.page.application.management.ApplicationPage
import org.solyton.solawi.bid.application.ui.page.application.management.ModulePage
import org.solyton.solawi.bid.application.ui.page.application.placeholder.ApplicationPlaceholderPage
import org.solyton.solawi.bid.application.ui.page.application.private.PrivateApplicationManagementPage
import org.solyton.solawi.bid.application.ui.page.application.private.PrivateApplicationOrganizationManagementPage
import org.solyton.solawi.bid.application.ui.page.auction.*
import org.solyton.solawi.bid.application.ui.page.banking.BankingApplicationForOrganizationsPage
import org.solyton.solawi.bid.application.ui.page.banking.OrganizationsWithBankingPage
import org.solyton.solawi.bid.application.ui.page.dashboard.DashboardPage
import org.solyton.solawi.bid.application.ui.page.distribution.DistributionManagementForOrganizationsPage
import org.solyton.solawi.bid.application.ui.page.distribution.OrganizationsWithDistributionPage
import org.solyton.solawi.bid.application.ui.page.login.LoginPage
import org.solyton.solawi.bid.application.ui.page.login.effect.LaunchLogoutEffect
import org.solyton.solawi.bid.application.ui.page.manual.HowToBidPage
import org.solyton.solawi.bid.application.ui.page.manual.HowToCarryOutAnAuctionPage
import org.solyton.solawi.bid.application.ui.page.manual.ManualPage
import org.solyton.solawi.bid.application.ui.page.manual.banking.BankingManualPage
import org.solyton.solawi.bid.application.ui.page.sendbid.SendBidPage
import org.solyton.solawi.bid.application.ui.page.sendbid.ShowQRCodePage
import org.solyton.solawi.bid.application.ui.page.shares.OrganizationsWithShareManagementPage
import org.solyton.solawi.bid.application.ui.page.shares.PersonalShareManagementPage
import org.solyton.solawi.bid.application.ui.page.shares.ShareManagementForOrganizationsPage
import org.solyton.solawi.bid.application.ui.page.test.FontsPage
import org.solyton.solawi.bid.application.ui.page.test.MobileTestPage
import org.solyton.solawi.bid.application.ui.page.test.TestButtonsPage
import org.solyton.solawi.bid.application.ui.page.test.TestPage
import org.solyton.solawi.bid.application.ui.page.user.OrganizationManagementPage
import org.solyton.solawi.bid.application.ui.page.user.OrganizationPage
import org.solyton.solawi.bid.application.ui.page.user.PrivateUserPage
import org.solyton.solawi.bid.application.ui.page.user.UserManagementPage
import org.solyton.solawi.bid.module.banking.application.BANKING_APPLICATION_NAME
import org.solyton.solawi.bid.module.bid.application.AUCTION_APPLICATION_NAME
import org.solyton.solawi.bid.module.distribution.application.DISTRIBUTION_APPLICATION_NAME
import org.solyton.solawi.bid.module.navbar.action.logoutAction
import org.solyton.solawi.bid.module.navbar.component.NavBar
import org.solyton.solawi.bid.module.process.component.ClearProcessOnRouteChange
import org.solyton.solawi.bid.module.shares.application.SHARE_MANAGEMENT_APPLICATION_NAME
import org.solyton.solawi.bid.module.user.action.user.GET_USERS
import org.solyton.solawi.bid.module.user.action.user.READ_USER_PROFILES
import org.solyton.solawi.bid.module.values.ProviderId

@RoutingDsl
@Composable
@Suppress("FunctionName", "CognitiveComplexMethod")
fun Routing(storage: Storage<Application>): Routes = Routing(
    initPath =  "/",
    redirect = { when{
        (storage * userData).read().seemsToBeLoggerIn() -> "/app/dashboard"
        else -> "/login"
    } }
) {
    route("bid") {
        route("send/:cryptoId") {
            component {
                SendBidPage(storage, "${parameter("cryptoId")}")
            }
        }
        route("qr-code/:cryptoId") {
            component {
                ShowQRCodePage(storage, "${parameter("cryptoId")}")
            }
        }
    }
    route("login") {
        component { LoginPage(storage) }
    }
    route("manual") {
        component { ManualPage(storage) }

        route("how-to-bid") {
            component { HowToBidPage(storage) }
        }
        route("banking") {
            component { BankingManualPage(storage) }
        }
        route("how-to-carry-ou-an-auction") {
            component { HowToCarryOutAnAuctionPage(storage) }
        }
    }
    route("app") {

        wrap {
            access {
                // todo:dev improve it
                when ((storage * userData).read().seemsToBeLoggerIn()) {
                    true -> {
                        //TriggerIsLoggedInEffect(storage)
                        true
                    }
                    false -> when {
                        currentPath().startsWith("/bid/send") -> true
                        currentPath().startsWith("/manual") -> true
                        currentPath().startsWith("/bid/qr-code") -> true
                        else -> {
                            navigate("/login")
                            false
                        }
                    }
                }
            }
            layout { page -> {
                NavBar(
                    navBar =storage * navBarIso,
                    device = storage * deviceData * mediaType.get,
                    logoutAction = logoutAction
                )

                VersionInfo(storage)

                // render page
                page()
            } }

            route("dashboard") {
                component { DashboardPage(storage) }
            }
            route("private/data") {
                component { PrivateUserPage(storage) }
            }
            route("management") {
                component{
                    ApplicationManagementPage(storage)
                }
                route("application/:applicationId") {
                    component {
                        ApplicationPage(
                            storage,
                            parameter("applicationId")!!
                        )
                    }
                    route("module/:moduleId") {
                        component {
                            ModulePage(
                                storage,
                                parameter("applicationId")!!,
                                parameter("moduleId")!!
                            )
                        }
                    }
                }

                route("private") {
                    component{
                        PrivateApplicationManagementPage(storage)
                    }
                    route("application/:applicationId") {
                        route("organization/:organizationId") {
                            component {
                                PrivateApplicationOrganizationManagementPage(
                                    storage,
                                    parameter("applicationId")!!,
                                    parameter("organizationId")!!
                                )
                            }
                        }
                    }
                    route("shares") {
                        component{
                            PersonalShareManagementPage(storage)
                        }
                    }
                }

                route("users") {
                    component {
                        UserManagementPage(
                            storage * userIso
                        )
                    }
                }
                route("organizations") {
                    component {
                        OrganizationManagementPage(
                            storage * userIso
                        )
                    }
                    route("with") {
                        route("shares") {
                            component{
                                OrganizationsWithShareManagementPage(storage)
                            }
                        }
                        route("auctions") {
                            component{
                                OrganizationsWithAuctionsPage(storage)
                            }
                        }
                        route("banking") {
                            component {
                                OrganizationsWithBankingPage(storage)
                            }
                        }
                        route("distribution"){
                            component {
                                OrganizationsWithDistributionPage(storage)
                            }
                        }
                    }
                    route(":organizationId") {
                        component {
                            ClearProcessOnRouteChange(
                                storage * processes,
                                GET_USERS,
                                READ_USER_PROFILES
                            ) {
                                OrganizationPage(
                                    storage,
                                    parameter("organizationId")!!
                                )
                            }
                        }
                        route(":application") {
                            component {
                                val organizationId = parameter("organizationId")!!
                                val application = parameter("application")!!
                                val up = "/app/management/organizations/$organizationId"
                                with(application.uppercase()) {
                                    when(this) {
                                        DISTRIBUTION_APPLICATION_NAME -> DistributionManagementForOrganizationsPage(
                                            storage,
                                            ProviderId(organizationId),
                                            up
                                        )
                                        SHARE_MANAGEMENT_APPLICATION_NAME -> ShareManagementForOrganizationsPage(
                                            storage,
                                            ProviderId(organizationId),
                                            up
                                        )
                                        BANKING_APPLICATION_NAME -> BankingApplicationForOrganizationsPage(
                                            storage,
                                            ProviderId(organizationId),
                                            up
                                        )
                                        AUCTION_APPLICATION_NAME -> AuctionsForOrganizationsPage(
                                            storage,
                                            ProviderId(organizationId),
                                            up
                                        )
                                        else -> ApplicationPlaceholderPage(storage, up)
                                    }
                                }
                            }
                        }
                    }
                }
            }

            route("auctions") {
                component {
                    AuctionsPage(storage)
                }
                route(":auctionId") {
                    component {
                        AuctionPage(storage, parameter("auctionId")!!)
                    }
                    route("rounds/:roundId") {
                        component {
                            val auctionId = parameter("auctionId")!!
                            val roundId = parameter("roundId")!!

                            RoundPage(
                                storage,
                                auctionId,
                                roundId
                            )
                        }

                        route("evaluation") {
                            component {
                                BidRoundEvaluationPage(
                                    storage,
                                    parameter("auctionId")!!,
                                )
                            }
                        }
                    }
                }
                route("search-bidders") {
                    component {
                        SearchBiddersPage(
                            storage
                        )
                    }
                }

            }
            route("logout") {
                component {
                    Text("Logged out")
                    LaunchLogoutEffect(storage)
                }
            }
        }
    }
    nonProdRoute(
        "test",
        (storage * environment * type).read()
    ){
        route("page") {
            component { TestPage() }
        }
        route("mobile") {
            component { MobileTestPage(storage) }
        }
        route("fonts") {
            component { FontsPage() }
        }
        route("buttons") {
            component{ TestButtonsPage() }
        }
    }
}
